import tippy from 'tippy.js';
import tooltipConfig from '../../01-atoms/tooltip/_tooltip';

const glossaryDataUrl = '/assets/statics/data/glossary.json';

const loadingMessage = 'Laden...';
const errorMessage = 'Netzwerkfehler...';

tippy('[data-ref]', {
  ...tooltipConfig,
  content: loadingMessage,
  onCreate(instance) {
    // Setup our own custom state properties
    const { state } = instance;
    state.isFetching = false;
    state.src = null;
    state.error = null;
  },
  onShow(instance) {
    const { state } = instance;
    const { ref } = instance.reference.dataset;

    if (state.isFetching || state.ref || state.error) {
      instance.setContent(state.ref);
      return;
    }

    state.isFetching = true;
    fetch(glossaryDataUrl)
      .then((response) => response.json())
      .then((data) => {
        state.ref = data[ref].description;
        instance.setContent(state.ref);
      })
      .catch((error) => {
        state.error = error;
        instance.setContent(`${errorMessage} <pre>${error}</pre>`);
      })
      .finally(() => {
        state.isFetching = false;
      });
  },
  onHidden(instance) {
    const { state } = instance;
    // Unset these properties so new network requests can be initiated
    state.error = null;
  },
});
